<template>
  <div class="product-accordion-item" :class="[{ 'product-accordion-item_active': item.active }, accordionItemTypeClass]">
    <div class="product-accordion-item__inner">
      <b class="product-accordion-item__title product-accordion-item__title_clickable" @click="toggleAccordion">
        <LockIcon :published-to="item.publishedTo" />
        {{ title }}
      </b>
      <SlideUpDown :active="item.active" :duration="1000" ref="inner-accordion">
        <div class="product-accordion-item__col-holder" :class="accordionItemTemplateType">
          <div class="product-accordion-item__col" v-if="isContentPresent">
            <div class="product-accordion-item__content" v-external-links-blank>
              <p v-if="longDescr.external" class="product-accordion-item__info" v-html="longDescr.external"></p>
              <p v-if="longDescr.internal" class="product-accordion-item__info internal-information" v-html="longDescr.internal"></p>
              <p v-if="shortDescr.external" class="product-accordion-item__info" v-html="shortDescr.external"></p>
              <p v-if="shortDescr.internal" class="product-accordion-item__info internal-information" v-html="shortDescr.internal"></p>
              <p v-if="description.internal" class="product-accordion-item__info internal-information" v-html="description.internal"></p>
              <p v-if="descr.external" class="product-accordion-item__info" v-html="descr.external"></p>
              <p v-if="descr.internal" class="product-accordion-item__info internal-information" v-html="descr.internal"></p>
              <p v-if="features.external" class="product-accordion-item__info" v-html="features.external"></p>
              <p v-if="features.internal" class="product-accordion-item__info internal-information" v-html="features.internal"></p>
              <p v-if="standardFittings.external" class="product-accordion-item__info" v-html="standardFittings.external"></p>
              <p
                v-if="standardFittings.internal"
                class="product-accordion-item__info internal-information"
                v-html="standardFittings.internal"
              ></p>
              <p v-if="altFittings.external" class="product-accordion-item__info" v-html="altFittings.external"></p>
              <p v-if="altFittings.internal" class="product-accordion-item__info internal-information" v-html="altFittings.internal"></p>
              <p v-if="endUserDescr.external" class="product-accordion-item__info" v-html="endUserDescr.external"></p>
              <p v-if="endUserDescr.internal" class="product-accordion-item__info internal-information" v-html="endUserDescr.internal"></p>
              <p v-if="notaBene.external" class="product-accordion-item__note" v-html="notaBene.external"></p>
              <p v-if="notaBene.internal" class="product-accordion-item__note" v-html="notaBene.internal"></p>
              <p v-if="erpCode" class="product-accordion-item__info internal-information" v-html="erpCode"></p>
              <p
                v-if="calculation.external || calculation.internal"
                class="product-accordion-item__info sub-heading"
                v-html="langJson[lang].calculations"
              ></p>
              <p v-if="calculation.external" class="product-accordion-item__info" v-html="calculation.external"></p>
              <p v-if="calculation.internal" class="product-accordion-item__info internal-information" v-html="calculation.internal"></p>
              <p v-if="serviceInfo" class="product-accordion-item__info sub-heading" v-html="langJson[lang].serviceInformation"></p>
              <p v-if="serviceInfo" class="product-accordion-item__info service-information" v-html="serviceInfo"></p>
            </div>
          </div>
          <div class="product-accordion-item__col" v-if="isResourcesPresent">
            <div class="product-accordion-item__media-list">
              <div class="product-accordion-item__media-list-inner">
                <div
                  v-for="(resource, index) in Array.from(resources.values())"
                  class="product-accordion-item__media-item"
                  :class="`product-accordion-item__media-item_${privacyTypeSlugs[resource.item.publishedTo]}`"
                  :key="'resource_' + index"
                >
                  <template v-if="item.productBlockType !== 'ProductCard'">
                    <div class="product-accordion-item__media-item-inner">
                      <LockIcon :published-to="resource.item.publishedTo" />
                      <div class="product-accordion-item__media-holder">
                        <div class="product-accordion-item__media-box">
                          <template v-if="resource.item.type === resourceTypes.VIDEO">
                            <div class="product-accordion-item__player" @click="play(index, $event)">
                              <span class="icon-player product-accordion-item__player-icon"></span>
                              <video width="250" height="250" @ended="onEnd">
                                <source :src="baseUrlMedia + resource.item.fileId + '/' + resource.item.fileName" type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          </template>
                          <template v-else>
                            <img
                              :src="previewImagePath(resource.item)"
                              @error="handleImageError"
                              :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                              class="product-accordion-item__image"
                            />
                          </template>
                        </div>
                      </div>
                      <div class="product-accordion-item__media-content">
                        <b class="product-accordion-item__media-title">
                          {{ setProperFieldExternalFirst(resource.item, 'title') }}
                        </b>
                      </div>
                      <div class="product-accordion-item__media-bottom-bar">
                        <product-downloads :resource="resource"></product-downloads>
                        <div class="product-accordion-item__media-details" @click="handleOpenProductDetails(resource, $event)">
                          <div class="product-accordion-item__media-details-button">
                            {{ langJson[lang].details }}
                            <i class="icon-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <img
                      :src="previewImagePath(resource.item)"
                      @error="handleImageError"
                      :alt="setProperFieldExternalFirst(resource.item, 'title') || 'image'"
                      class="product-accordion-item__image"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SlideUpDown>
      <div class="product-accordion-item__toggle-btn" @click="toggleAccordion">
        <div class="product-accordion-item__toggle-btn-inner">
          <span v-if="item.active">
            {{ langJson[lang].minimize }}
            <span class="product-accordion-item__minus"></span>
          </span>
          <span v-else>
            {{ langJson[lang].expand }}
            <span class="product-accordion-item__plus"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { handleImageError } from '~/utils/imageFallback';
  import { privacyTypeSlugs, resourceTypes, resourceDisplayPriority } from '@/constants/index.js';

  interface ResourceFileItem {
    fileName: string;
    mimeType: string;
    fileId: string;
    publishedTo: number;
    extension: string;
    type?: string;
    coverImageId?: string;
    coverImageName?: string;
    external?: Record<string, string>;
    internal?: Record<string, string>;
    [key: string]: unknown;
  }

  interface ResourceGroup {
    item: ResourceFileItem;
    items: ResourceFileItem[];
  }

  interface WindowWithGtm extends Window {
    $gtm?: { pushEvent: (data: Record<string, unknown>) => void };
  }

  // Define emitted events used in handlers below
  const emit = defineEmits(['onToggle', 'updateState']);

  const props = defineProps({
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    open: {
      type: Number,
      default: 0
    },
    close: {
      type: Number,
      default: 0
    },
    allExpanded: {
      type: Boolean,
      default: false
    }
  });

  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);

  const imgRatio = '?width=300&height=300';
  const imgMaxSize = '&width=300&height=300';
  const filePreview = '/Preview?mimetype=image/jpg';

  function removeFileNameExtension(x: string) {
    return x.replace(/\.[^/.]+$/, '');
  }
  function extractExtensionFromFileName(x: string) {
    return x.split('.').pop();
  }
  function getLengthEvery(...args: unknown[]) {
    return args.reduce((acc: number, x) => acc + (x && typeof x === 'string' ? x.length : 0), 0);
  }
  function getResourceType(mimeType: string, extension: string) {
    const fileExtensions = ['pdf', 'dwg', 'doc', 'xls'];
    const videoMimeTypes = ['application/octet-stream'];
    if (mimeType.includes('image')) {
      return resourceTypes.IMAGE;
    } else if (videoMimeTypes.includes(mimeType) && !fileExtensions.includes(extension)) {
      return resourceTypes.VIDEO;
    } else {
      return resourceTypes.FILE;
    }
  }

  function setProperFieldExternal(obj: Record<string, unknown> | null | undefined, field: string): string {
    const o = obj as Record<string, Record<string, string> | unknown> | null | undefined;
    return (o && (o.external as Record<string, string>)?.[field]) || String(o?.[field] || '');
  }
  function setProperFieldInternal(obj: Record<string, unknown> | null | undefined, field: string): string {
    const o = obj as Record<string, Record<string, string> | unknown> | null | undefined;
    return (o && (o.internal as Record<string, string>)?.[field]) || '';
  }
  function setProperFieldExternalFirst(obj: Record<string, unknown> | null | undefined, field: string): string {
    const o = obj as Record<string, Record<string, string> | unknown> | null | undefined;
    return (o?.external as Record<string, string>)?.[field] || (o?.internal as Record<string, string>)?.[field] || '';
  }

  const active = ref(props.item.active);
  function breakRefs(data: unknown) {
    return JSON.parse(JSON.stringify(data));
  }
  function prepareResources(resources: ResourceFileItem[]) {
    const map = new Map<string, ResourceGroup>();
    if (resources === null) return map;
    resources.forEach((item) => {
      const resourceName = removeFileNameExtension(item.fileName);
      const extension = extractExtensionFromFileName(item.fileName) || '';
      const collection = map.get(resourceName);
      if (!collection) {
        map.set(resourceName, {
          item: { ...item, extension, type: getResourceType(item.mimeType, extension || '') },
          items: [{ ...item, extension }]
        });
      } else {
        if (
          resourceDisplayPriority !== undefined &&
          extension &&
          resourceDisplayPriority.indexOf(extension) > resourceDisplayPriority.indexOf(collection.item.extension || '')
        ) {
          collection.item = {
            ...item,
            extension,
            type: getResourceType(item.mimeType, extension || '')
          };
          collection.items.unshift({ ...item, extension });
        } else {
          collection.items.push({ ...item, extension });
        }
      }
    });
    return map;
  }
  const resources = computed(() => prepareResources(breakRefs(props.item.resources)));

  const title = computed(() => setProperFieldExternalFirst(props.item, 'title'));
  const shortDescr = computed(() => ({
    external: setProperFieldExternal(props.item, 'shortDescr'),
    internal: setProperFieldInternal(props.item, 'shortDescr')
  }));
  const description = computed(() => ({
    external: setProperFieldExternal(props.item, 'description'),
    internal: setProperFieldInternal(props.item, 'description')
  }));
  const descr = computed(() => ({
    external: setProperFieldExternal(props.item, 'descr'),
    internal: setProperFieldInternal(props.item, 'descr')
  }));
  const longDescr = computed(() => ({
    external: setProperFieldExternal(props.item, 'longDescr'),
    internal: setProperFieldInternal(props.item, 'longDescr')
  }));
  const altFittings = computed(() => ({
    external: setProperFieldExternal(props.item, 'altFittings'),
    internal: setProperFieldInternal(props.item, 'altFittings')
  }));
  const standardFittings = computed(() => ({
    external: setProperFieldExternal(props.item, 'standardFittings'),
    internal: setProperFieldInternal(props.item, 'standardFittings')
  }));
  const features = computed(() => ({
    external: setProperFieldExternal(props.item, 'features'),
    internal: setProperFieldInternal(props.item, 'features')
  }));
  const calculation = computed(() => ({
    external: setProperFieldExternal(props.item, 'calculation'),
    internal: setProperFieldInternal(props.item, 'calculation')
  }));
  const endUserDescr = computed(() => ({
    external: setProperFieldExternal(props.item, 'endUserDescr'),
    internal: setProperFieldInternal(props.item, 'endUserDescr')
  }));
  const notaBene = computed(() => ({
    external: setProperFieldExternal(props.item, 'notaBene'),
    internal: setProperFieldInternal(props.item, 'notaBene')
  }));
  const serviceInfo = computed(() => setProperFieldExternalFirst(props.item, 'serviceInfo'));
  const erpCode = computed(() => setProperFieldExternalFirst(props.item, 'erpCode'));

  const isContentPresent = computed(
    () =>
      getLengthEvery(
        standardFittings.value.external,
        endUserDescr.value.external,
        description.value.external,
        altFittings.value.external,
        calculation.value.external,
        shortDescr.value.external,
        longDescr.value.external,
        features.value.external,
        notaBene.value.external,
        descr.value.external,
        shortDescr.value.internal,
        description.value.internal,
        descr.value.internal,
        longDescr.value.internal,
        altFittings.value.internal,
        standardFittings.value.internal,
        features.value.internal,
        calculation.value.internal,
        endUserDescr.value.internal,
        notaBene.value.internal,
        erpCode.value,
        serviceInfo.value
      ) > 0
  );
  const isResourcesPresent = computed(() => props.item.resources && props.item.resources.length > 0);
  const displayedResourcesCount = computed(() => resources.value.size);
  const accordionItemTemplateType = computed(() => {
    let type = null;
    if (isResourcesPresent.value && isContentPresent.value) {
      if (displayedResourcesCount.value === 1) type = 'product-accordion-item__col-holder_wide-text';
      if (displayedResourcesCount.value === 2) type = 'product-accordion-item__col-holder_narrow-text';
      if (displayedResourcesCount.value > 2) type = 'product-accordion-item__col-holder_block-text';
    } else {
      if (isContentPresent.value) type = 'product-accordion-item__col-holder_only-content';
      if (isResourcesPresent.value) type = 'product-accordion-item__col-holder_only-resources';
    }
    return type;
  });
  const accordionItemTypeClass = computed(() => {
    const accordionItemType = props.item.publishedTo;
    switch (accordionItemType) {
      case 1:
        return 'product-accordion-item_external';
      case 2:
        return 'product-accordion-item_internal';
      case 3:
        return 'product-accordion-item_service';
      default:
        return '';
    }
  });

  function openProductDetails(resource: ResourceGroup) {
    // Implement as needed or port from Vuex action
  }
  function previewImagePath(file: ResourceFileItem) {
    if (file.mimeType.includes('application')) {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + filePreview + imgMaxSize;
    } else {
      return baseUrlMedia.value + file.fileId + '/' + file.fileName + imgRatio;
    }
  }
  function handleOpenProductDetails(resource: ResourceGroup, event: Event) {
    const productResourceTitle =
      resource.item.external && resource.item.external.title ? resource.item.external.title : resource.item.internal?.title;
    if (window && (window as unknown as WindowWithGtm).$gtm) {
      (window as unknown as WindowWithGtm).$gtm?.pushEvent({
        productResourceTitle: productResourceTitle,
        event: event
      });
    }
    if (mainStore.openProductDetails) mainStore.openProductDetails(resource);
  }
  function filePreviewImagePath(file: ResourceFileItem) {
    if (file.coverImageId && file.coverImageName) {
      return baseUrlMedia.value + file.coverImageId + '/' + file.coverImageName + filePreview + imgMaxSize;
    }
    return baseUrlMedia.value + file.fileId + '/' + file.fileName + filePreview + imgMaxSize;
  }
  function openAccordion() {
    active.value = true;
  }
  function toggleAccordion() {
    emit('onToggle', props.index);
  }
  function play(index: number, event: Event) {
    if (event.target) {
      const target = event.target as HTMLElement;
      const videoElement = target.childNodes[2] as HTMLVideoElement;
      if (videoElement && videoElement.paused) {
        target.classList.add('playing');
        videoElement.play();
      } else if (videoElement) {
        target.classList.remove('playing');
        videoElement.pause();
      }
    }
  }
  function onEnd(event: Event) {
    if (event.target) {
      const target = event.target as HTMLElement;
      if (target.parentNode) {
        (target.parentNode as HTMLElement).classList.remove('playing');
      }
    }
  }
  function openItem() {
    active.value = true;
  }
  function openAllPublicItemsAndCloseInternal() {
    active.value = !(props.item.publishedTo === 2 || props.item.publishedTo === 3);
    emit('updateState', {
      index: props.index,
      value: active.value
    });
  }
  function closeItem() {
    active.value = false;
  }
</script>
